import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import axios from "axios";
import Swal from "sweetalert2";
import BaseInputList from "../../ui/inputs/BaseInputList/BaseInputList";
import "./ScheduleTimeComponent.css";
import {
  BoltIcon,
  LeftArrowIconCircle,
  RightArrowIconCircle,
} from "../../constants/icons";
import BaseInput from "../../ui/inputs/BaseInput/BaseInput";
const DateScheduler = () => {
  const [selectedTime, setSelectedTime] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedDate, setSelectedDate] = useState({
    day: "ASAP",
    month: getAsapIcon(),
    dayNumber: "-",
    index: 0,
  });
  const scheduleOptions = [
    { day: "ASAP", month: getAsapIcon(), dayNumber: "-", index: 0 },
    ...getNext8Days(),
  ];
  const dateOptionsRef = useRef(null);
  const [pageNumber, setPageNumber] = useState(0);
  const timeOptions = [
    {
      value: "8:30 AM",
      label: "8:30 AM",
    },
    {
      value: "9:00 AM",
      label: "9:00 AM",
    },
    {
      value: "9:30 AM",
      label: "9:30 AM",
    },
    {
      value: "10:00 AM",
      label: "10:00 AM",
    },
    {
      value: "10:30 AM",
      label: "10:30 AM",
    },
    {
      value: "11:00 AM",
      label: "11:00 AM",
    },
    {
      value: "11:30 AM",
      label: "11:30 AM",
    },
    {
      value: "12:00 PM",
      label: "12:00 PM",
    },
    {
      value: "12:30 PM",
      label: "12:30 PM",
    },
    {
      value: "1:00 PM",
      label: "1:00 PM",
    },
    {
      value: "1:30 PM",
      label: "1:30 PM",
    },
    {
      value: "2:00 PM",
      label: "2:00 PM",
    },
    {
      value: "2:30 PM",
      label: "2:30 PM",
    },
    {
      value: "3:00 PM",
      label: "3:00 PM",
    },
    {
      value: "3:30 PM",
      label: "3:30 PM",
    },
    {
      value: "4:00 PM",
      label: "4:00 PM",
    },
    {
      value: "4:30 PM",
      label: "4:30 PM",
    },
    {
      value: "5:00 PM",
      label: "5:00 PM",
    },
    {
      value: "5:30 PM",
      label: "5:30 PM",
    },
    {
      value: "6:00 PM",
      label: "6:00 PM",
    },
    {
      value: "6:30 PM",
      label: "6:30 PM",
    },
    {
      value: "7:00 PM",
      label: "7:00 PM",
    },
    {
      value: "7:30 PM",
      label: "7:30 PM",
    },
    {
      value: "8:00 PM",
      label: "8:00 PM",
    },
  ];
  const listingData = useSelector((state) => state.listingData);

  const MySwal = Swal.mixin();

  function getAsapIcon() {}

  function getNext8Days() {
    const today = new Date();
    const next8Days = [];

    for (let i = 1; i <= 8; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      const day = date.toLocaleDateString("en-US", { weekday: "short" });
      const month = date.toLocaleDateString("en-US", { month: "short" });
      const dayNumber = date.getDate();
      next8Days.push({
        day: day,
        month: month,
        dayNumber: dayNumber,
        index: i,
      });
    }

    return next8Days;
  }

  function scheduleATour(scheduleData) {
    const isLogin = localStorage.getItem("MyRTP");

    if (isLogin === false) {
      var loginForm = document.getElementById("root-react-login-form");

      if (loginForm) {
        loginForm.setAttribute("visible", "true");
      }
    } else {
      let url = "/api/schedule-a-tour";

      axios
        .post(url, scheduleData)
        .then(function (response) {
          MySwal?.fire({
            title: "Schedule Tour request sent!",
            text: "",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Close",
          });
          document.querySelector(".mg-error").textContent = "";
          document.querySelector(".mg-error").style.display = "none";
          if (response.data.success) {
            document.querySelector("#contactModal").style.display = "none";
            document.querySelector("#checkbox-modal").style.display = "block";
          }
        })
        .catch(function (error) {
          console.log("Error");
        });
    }
  }
  const handleChangePhone = (e) => {
    setPhoneNumber(e.currentTarget.value)
  }
  const handleScheduleClick = () => {
    // const ScheduleTourEvent=new CustomEvent("ScheduleTourEvent",{
    //     detail:{
    //         datetime:{
    //              day:selectedDate?.day,
    //              month:selectedDate?.month,
    //              dayNumber:selectedDate?.dayNumber,
    //              time:selectedTime?.value
    //         }
    //     }
    // })
    // document.dispatchEvent(ScheduleTourEvent);
    let scheduleData = {
      day: selectedDate?.day,
      month: selectedDate?.month,
      dayNumber: selectedDate?.dayNumber,
      time: selectedTime?.value,
    };
    //console.log('scheduleData', scheduleData)
    if (scheduleData && scheduleData.day && scheduleData.time) {
      if(phoneNumber.length < 10){
        return MySwal?.fire({
          title: "Please, Enter a valid phone number.",
          text: "",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Close",
        });
      }
      scheduleData = {
        date: `${scheduleData?.day} ${
          (scheduleData && scheduleData?.dayNumber) || ""
        } ${scheduleData?.day == "ASAP" ? "" : scheduleData?.month || ""}`,
        time: scheduleData.time,
        address: `${(listingData && listingData.data?.Address) || ""}, ${
          (listingData && listingData.data?.City) || ""
        }, ${(listingData && listingData.data?.StateOrProvince) || ""} ${
          (listingData && listingData.data?.PostalCode) || ""
        }`,
        url: window.location.href,
        phoneNumber: phoneNumber
      };

      let UserID = localStorage.getItem("MyRTP");

      if (UserID) {
        var jsonObject = JSON.parse(UserID);

        scheduleData.id = jsonObject.SubjectID;

        scheduleATour(scheduleData);
      } else {
        let callbackFuntion = (data) => {
          let userString = localStorage.getItem("user");
          let userObject = userString ? JSON.parse(userString) : null;
          let UserID = userObject && userObject.ClientID;
          data.id = UserID;
          if (UserID) {
            scheduleATour(data);

            let unlockPremiumBtns = document.querySelectorAll(
              ".active-listings-house-card-gallery-no-login-btn"
            );
            let slikSliderImages = document.querySelectorAll(
              ".blur-image-inline-slider"
            );
            if (slikSliderImages) {
              slikSliderImages.forEach((img) => {
                img.classList.remove("blur-image-inline-slider");
              });
            }
            if (unlockPremiumBtns) {
              unlockPremiumBtns.forEach((btn) => {
                btn.remove();
              });
            }
            if (window.RTAfterLogin) {
              delete window.RTAfterLogin;
            }
          } else {
            window.location.reload();
          }
        };

        var loginForm = document.getElementById("root-react-login-form");

        if (loginForm) {
          loginForm.setAttribute("visible", "true");
        }
      }
    } else {
      MySwal?.fire({
        title: "Please, Select a valid schedule!",
        text: "",
        icon: "error",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Close",
      });
    }
  };

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-arrow date-scheduler-nextArrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      //   aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
      aria-label="Previous image button"
    >
      <RightArrowIconCircle />
    </button>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-arrow date-scheduler-prevArrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      //   aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
      aria-label="Next image button"
    >
      <LeftArrowIconCircle />
    </button>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    swipeToSlide: true,
    // lazyLoad: "ondemand",
    lazyLoad: true,
    nextArrow: <SlickArrowLeft />,
    prevArrow: <SlickArrowRight />,
    // afterChange: (slide) => {
    //   setCurrentSlide(slide + 1);
    // },
  };

  return (
    <div className="date-scheduler">
      <div className="row listerning-page-left-part-search-block-title">
        <h3 className="title">Schedule Tour</h3>
      </div>
      <div className="row banner-container" style={{ position: "relative" }}>
        {/* <div className="scroll-button left" onClick={scrollLeft}>
           <LeftArrowIconCircle color='#2178bd'/>
        </div> */}
        {/* <div className='banner-date-wrapper'>
            <div className="date-selector" ref={dateOptionsRef}>
            {scheduleOptions.map((time, index) => (
                <div className={`time-option ${selectedDate?.index === time?.index ? 'selected' : ''}`} key={index} onClick={() => setSelectedDate(time)}>
                    <div className="time-text">{time.day}</div>
                    <div className="time-text">{time.month}</div>
                    <div className="time-text">{time.dayNumber}</div>
                </div>
            ))}
            </div>
        </div> */}
        <Slider {...settings} initialSlide={pageNumber} ref={dateOptionsRef}>
          {scheduleOptions.map((time, index) => (
            <div
              className={`date-option ${
                selectedDate?.index === time?.index ? "selected" : ""
              }`}
              key={index}
              onClick={() => setSelectedDate(time)}
            >
              <div className="time-text">{time.day}</div>
              <div className="time-text">{time.month}</div>
              <div className="time-text">{time.dayNumber}</div>
            </div>
          ))}
        </Slider>

        {/* <div className="scroll-button right" onClick={scrollRight}>
          <RightArrowIconCircle color='#2178bd'/>
        </div> */}
      </div>
      <div className="row select-time">
        <div className="form-label">Time</div>
        <BaseInputList
          // placeholder="Select a Time:"
          placeholder="Select a Time:"
          readonly={true}
          list={timeOptions}
          setInputValue={setSelectedTime}
          inputValue={selectedTime}
          field="label"
          listTop="44px"
          name="selectedTime"
          valueOnly={true}
        />
      </div>
      <div className="row select-time">
        <div className="form-label">Contact Info</div>
        <BaseInput value={phoneNumber || ""} onChange={handleChangePhone} placeholder={"Enter Phone Number"}/>
      </div>
      <div className="row schedule-btn">
        <button
          className="schedule-button"
          onClick={handleScheduleClick}
          aria-label="Schedule button"
        >
          Schedule Tour
        </button>
      </div>
    </div>
  );
};

export default DateScheduler;
